import warehouse from "./warehouse";
import mainProduct from "./mainProduct";
import subProduct from "./subProduct";
import product from "./product";
import cutOffStock from "./cutOffStock";
import unit from "./unit";
import productUnitRelation from "./productUnitRelation";

export default {
  warehouse,
  mainProduct,
  subProduct,
  product,
  cutOffStock,
  unit,
  productUnitRelation,
};
